<template>
  <Transition
    mode="out-in"
    :enter-from-class="enterFromClass"
    :enter-to-class="enterToClass"
    :leave-to-class="leaveToClass"
    :leave-from-class="leaveFromClass"
    enter-active-class="ease-fast-effect transition-all duration-200"
    leave-active-class="ease-fast-effect transition-all duration-300 delay-200"
  >
    <slot />
  </Transition>
</template>
<script setup lang="ts">
  import { computed } from 'vue'

  interface Props {
    direction: 'next' | 'previous'
  }

  const props = defineProps<Props>()

  const enterFromClass = computed<string>(() => {
    if (props.direction == 'previous') {
      return '-translate-x-full opacity-0'
    }
    return 'opacity-0 scale-90'
  })

  const enterToClass = computed<string>(() => {
    return 'translate-x-0 opacity-100 scale-100'
  })

  const leaveToClass = computed<string>(() => {
    if (props.direction == 'previous') {
      return 'opacity-0 scale-90'
    }
    return '-translate-x-full opacity-0'
  })
  const leaveFromClass = computed<string>(() => {
    return 'translate-x-0 opacity-100 scale-100'
  })
</script>
